interface ProductOnQuoteNoticeProps {
	/** The tiers the product already has on the quote, for context. */
	quantities: number[];
}

/**
 * Shown in place of the quantity fields when a product is already on the chosen
 * quote.
 *
 * `addOrderQuoteItems` refuses a product that is already there — and refuses the
 * whole batch over it — so there is nothing to type here. Changing its tiers
 * happens on the quote itself, where they can be addressed by id and the edit
 * can say what it costs.
 */
export function ProductOnQuoteNotice({ quantities }: ProductOnQuoteNoticeProps) {
	return (
		<div className="rounded-lg border border-line-1 bg-surface-sunken px-2.5 py-2">
			<span className="text-2xs font-medium text-text-3">Already on this quote</span>
			{quantities.length > 0 && (
				<div className="mt-1.5 flex flex-wrap gap-1">
					{quantities.map((quantity) => (
						<span
							key={quantity}
							className="inline-flex items-center rounded-md border border-line-2 bg-surface-fill px-2 py-0.5 font-mono text-xs font-medium text-text-2"
						>
							{quantity.toLocaleString()}
						</span>
					))}
				</div>
			)}
			<p className="mt-1.5 text-2xs text-text-4">
				It will be skipped. To change its quantities, open the quote.
			</p>
		</div>
	);
}
